import React from "react";

const WhatsappIcon = () => {
  return (
    <>
      <div className="whatsapp_float">
        <a href="https://wa.me/918878159423" target="_blank">
          <img
            src="assets/WhatsappLogo_1.webp"
            width="50px"
            className="whatsapp_float_btn"
          />
        </a>
      </div>
    </>
  );
};

export default WhatsappIcon;
